import moment from "moment";
import "moment/locale/ja";

export const FIREBASE_MSG_URL = "https://fcm.googleapis.com/fcm/send";
export const FIREBASE_SERVER_KEY = "";
export const FIREBASE_STORAGE_URL =
  "https://firebasestorage.googleapis.com/v0/b/fashion-app-7b64c.appspot.com/o/";

export const MAIL_CHECK =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const FIREBASE_IMAGE = (folder, name) => {
  return FIREBASE_STORAGE_URL + folder + "%2F" + name;
};

export const FETCH_AUTH = "FETCH_AUTH";
export const FETCH_AUTH_SUCCESS = "FETCH_AUTH_SUCCESS";
export const FETCH_AUTH_FAIL = "FETCH_AUTH_FAIL";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAIL = "FETCH_USER_FAIL";
export const SET_FIRESTORE_USER = "SET_FIRESTORE_USER";
export const REMOVE_FIRESTORE_USER = "REMOVE_FIRESTORE_USER";
export const SET_STRIPE_DATA = "SET_STRIPE_DATA";
export const FETCH_POST = "FETCH_POST";
export const FETCH_POST_SUCCESS = "FETCH_POST_SUCCESS";
export const FETCH_POST_FAIL = "FETCH_POST_FAIL";
export const FETCH_MUTE_IDS = "FETCH_MUTE_IDS";
export const FETCH_MUTE_IDS_SUCCESS = "FETCH_MUTE_IDS_SUCCESS";
export const FETCH_MUTE_IDS_FAIL = "FETCH_MUTE_IDS_FAIL";
export const FETCH_DELETED_USER = "FETCH_DELETED_USER";
export const FETCH_DELETED_USER_SUCCESS = "FETCH_DELETED_USER_SUCCESS";
export const FETCH_DELETED_USER_FAIL = "FETCH_DELETED_USER_FAIL";

export const StrsGender = ["女性", "男性", "指定なし", "キャンセル"];

export const num_delimiter = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const price_delimiter = (number) => {
  return num_delimiter(number) + " 円";
};

export const PREFECTURES = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export const get_approve_status = (status) => {
  switch (status) {
    case 0:
      return "承認待ち";
    case 1:
      return "否認";
    case 2:
      return "承認";
    default:
      return "";
  }
};

export const StrApprove = ["承認待ち", "否認", "承認"];

export const USER_KIND = ["匿名", "会員", "モデル"];

export const StrGenders = ["女性", "男性", "指定なし"];

export const STR_USER = (key, value) => {
  switch (key) {
    case "key":
      return ["KEY", value];
    case "kind":
      return ["アカウント種類", USER_KIND[value ?? 0]];
    case "uid":
      return ["ID", value];
    case "name":
      return ["名前", value ?? "未定"];
    case "nameKana":
      return ["名前（カナ）", value ?? "未定"];
    case "introduction":
      return ["紹介文", value ?? "未定"];
    case "timestamp":
      return ["登録日", value ? moment(value).format("YYYY年M月D日") : "未定"];
    case "height":
      return ["身長", value ?? "未定"];
    case "weight":
      return ["体重", value ?? "未定"];
    case "gender":
      return ["性別", StrGenders[2 - (value ?? 0)]];
    case "email":
      return ["メールアドレス", value ?? "未定"];
    case "imgFront":
      return ["身分証【オモテ面】", value, 0];
    case "imgFace":
      return ["顔画像", value, 0];
    case "imgBack":
      return ["身分証【ウラ面】", value, 0];
    case "image":
      return ["アイコン", value, 0];
    case "image1":
      return ["審査用写真1", value, 0];
    case "image2":
      return ["審査用写真2", value, 0];
    case "image3":
      return ["審査用写真3", value, 0];
    case "token":
      return ["トークン", value ?? "未定"];
    case "approve":
      return ["モデル登録ステータス", get_approve_status(value ?? 0)];
    case "modelName":
      return ["氏名", value ?? "未定"];
    case "modelNameKana":
      return ["氏名(フリガナ)", value ?? "未定"];
    case "modelGender":
      return ["性別", StrGenders[2 - (value ?? 0)]];
    case "modelBirthday":
      return [
        "生年月日",
        value ? moment(value).format("YYYY年M月D日") : "未定",
      ];
    case "modelEmail":
      return ["メールアドレス", value ?? "未定"];
    case "modelTel":
      return ["電話番号", value ?? "未定"];
    case "deviceName":
      return ["機種", value ?? "未定"];
    case "modelTimestamp":
      return [
        "モデル登録日",
        value ? moment(value).format("YYYY年M月D日") : "未定",
      ];
    case "isBlocked":
      return ["アカウント", value ? "無効" : "有効"];
    case "isTestAccount":
      return ["テストアカウント", value ? "有効" : "無効"];
    case "rakutenTrackingId":
      return ["楽天トラッキングID", value ?? ""];
    default:
      return [key, value];
  }
};

export const MsgAllowModel = (name) => {
  return {
    title: "モデル審査を無事通過しました",
    content:
      "TIPSNAPをご愛用頂き、誠にありがとうございます。\n\n" +
      "モデル登録内容を運営事務局内で審査いたしました。\n" +
      "審査の結果、" +
      name +
      "様、無事通過いたしました。\n" +
      "モデル権限をお持ちの方のみ、コーディネイト投稿ができるのようになります。\n" +
      "アプリ再起動後に、モデルの機能が追加されます。\n\n" +
      name +
      "様のファッションを世の中にシェアしてください！\n" +
      "引き続きよろしくお願いいたします！",
  };
};
export const MsgRejectModel = (name) => {
  return {
    title: "モデル審査を実施いたしました",
    content:
      "TIPSNAPをご愛用頂き、誠にありがとうございます。\n\n" +
      "モデル登録内容を運営事務局内で審査いたしました。\n" +
      "誠に残念ながら、審査の結果、" +
      name +
      "様には、モデル権限の付与ができませんでした。\n" +
      "コーディネイト投稿機能はお使いいただけませんが、\n" +
      "引き続き、TIPSNAPにてお楽しみいただけると幸いです。\n\n" +
      "よろしくお願いいたします！",
  };
};
